import React, { useMemo } from 'react';
import { batch } from 'react-redux';
import {
  IRowMeta,
  removeErrorAction,
  setCohortRowOperatorValues,
  setCohortRowTimeWindowValues,
} from '../../../../redux/slices/oldBuilder';
import { errorPrimitiveSelector } from '../../../../redux/selectors/builder';
import { toInteger } from 'lodash';
import { isNotNil } from '../../../../utils/types';
import { generateCustomRetentionTimeBracketText } from './utils';
import { SingleSelectMenu } from '../../../Dropdown';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { TimeUnit } from '../../../../utils/apollo/graphqlSchema';

interface IProps {
  customTimeBrackets: number[];
  retentionUnit: TimeUnit;
  rowMeta: IRowMeta;
  value: number | null;
  // as same as errorKey
  type: 'operatorValues' | 'timeWindowValues';
}

export default ({
  customTimeBrackets,
  retentionUnit,
  rowMeta,
  type,
  value,
}: IProps) => {
  const dispatch = useAppDispatch();

  const errorSelector = useMemo(errorPrimitiveSelector, []);
  const errors = useAppSelector((state) => errorSelector(state, rowMeta, type));

  const handleChange = (newValue: string) => {
    const setValueAction =
      type === 'timeWindowValues'
        ? setCohortRowTimeWindowValues
        : setCohortRowOperatorValues;

    batch(() => {
      dispatch(removeErrorAction({ rowMeta, errorKey: type }));
      dispatch(setValueAction({ rowMeta, newValue: toInteger(newValue) }));
    });
  };

  // generate time window value options from int array to the text:
  // for example: [1, 2, 3] => ['day 0 ', 'day 1 - 3', 'day 3 - 6']
  const options = useMemo(
    () =>
      customTimeBrackets.map((_, index) => ({
        value: index.toString(),
        text: generateCustomRetentionTimeBracketText(
          index,
          customTimeBrackets,
          retentionUnit,
        ),
      })),
    [customTimeBrackets, retentionUnit],
  );

  return (
    <SingleSelectMenu
      options={options}
      value={isNotNil(value) ? value.toString() : undefined}
      onChange={handleChange}
      placeholder="Select"
      hasError={isNotNil(errors)}
    />
  );
};
